import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {

  transform(value: string | Date, format: string = 'DD-MMM-YYYY hh:mm A'): string {
    let final = '-';
    if (value) {
      let dateRecivedUtcToLocal = new Date(value);
      switch (format) {
        case 'date': {
          format = "DD-MMM-YYYY";
        } break;
        case 'time': {
          format = "hh:mm A";
        } break;
        case 'longTime': {
          format = "hh:mm:ss A";
        } break;
      }
      final = this.toMoment(dateRecivedUtcToLocal).local().format(format);
    }
    return final;
  }

  toMoment(dt?: Date): moment.Moment {
    return dt ? moment.utc(dt) : moment.utc();
  }

  toUtcMoment(year: number, month: number, day: number, hours: number, minutes: number, seconds: number): moment.Moment {
    return moment('' + year + '/' + month + '/' + day + ' ' + hours + ':' + minutes + ':' + seconds + '', "dd/MM/yyyy hh:mm:ss");
  }

  getDeviceDate(): Date {
    return moment().toDate();
  }

  getDeviceDateWithFormat(format: string = 'DD-MMM-YYYY hh:mm A'): string {
    return this.toMoment(moment().toDate()).local().format(format);
  }

  getUtcOffset(): number {
    return moment().utcOffset();
  }

  getLocalTimeDifference(date: Date = null): number[] {
    if (date == null)
      date = this.getDeviceDate();
    let hoursMinutes: number[] = [];
    let strGmtDiffernces = date.toString().split("GMT");
    if (strGmtDiffernces && strGmtDiffernces.length > 0 && strGmtDiffernces[1]) {
      let strGmtDiffernce = strGmtDiffernces[1].substring(0, 5);
      let iHours = parseInt(strGmtDiffernce[1] + strGmtDiffernce[2]);
      let iMinutes = parseInt(strGmtDiffernce[3] + strGmtDiffernce[4]);
      hoursMinutes.push(strGmtDiffernce[0] == "-" ? -iHours : iHours);
      hoursMinutes.push(strGmtDiffernce[0] == "-" ? -iMinutes : iMinutes);

    } else {
      hoursMinutes.push(0);
      hoursMinutes.push(0);
    }
    return hoursMinutes;
  }

  getFromString(date: string): string {
    let dateRtn = '';
    let dates = date.split('-');
    dateRtn = dates[0] + "-" + this.getMonthName(parseInt(dates[1])) + "-" + dates[2];
    return dateRtn;
  }

  getMonthName(month: number): string {
    let monthName = '';
    switch (month) {
      case 1: {
        monthName = 'Jan';
      } break;
      case 2: {
        monthName = 'Feb';
      } break;
      case 3: {
        monthName = 'Mar';
      } break;
      case 4: {
        monthName = 'Apr';
      } break;
      case 5: {
        monthName = 'May';
      } break;
      case 6: {
        monthName = 'Jun';
      } break;
      case 7: {
        monthName = 'Jul';
      } break;
      case 8: {
        monthName = 'Aug';
      } break;
      case 9: {
        monthName = 'Sep';
      } break;
      case 10: {
        monthName = 'Oct';
      } break;
      case 11: {
        monthName = 'Nov';
      } break;
      case 12: {
        monthName = 'Dec';
      } break;
    }
    return monthName;
  }
}
